var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconScheduleUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 62,
    viewBox: "0 0 65 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 37,
    r: 8,
    fill: "#C175EE",
    stroke: "#1A3958",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 46.5C43.9005 46.1693 44.3884 45.6637 44.6967 45.3325C44.8917 45.1229 45.1639 45 45.4502 45H51.7074C51.8985 45 52.0854 45.0547 52.247 45.1565C52.714 45.4508 53.7472 46.0933 54.5 46.5C56.7333 47.7066 58.6276 47.2861 60.5 49C62.536 50.8637 63.2236 55.0308 63.4256 56.7432C63.4783 57.19 63.2097 57.6003 62.782 57.7397C60.6377 58.438 54.1423 60.4269 49.5 60.5C44.5083 60.5786 37.47 58.4603 35.2207 57.7376C34.7912 57.5996 34.5218 57.1885 34.5747 56.7405C34.7771 55.0265 35.465 50.8627 37.5 49C39.3724 47.2861 41.5426 48.1162 43.5 46.5Z",
    fill: "#C175EE",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 25V9.5C51 7.29086 49.2091 5.5 47 5.5H5C2.79086 5.5 1 7.29086 1 9.5V47C1 49.2091 2.79086 51 5 51H31.3891",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16H51",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9V2C9.5 1.44772 9.94772 1 10.5 1H14C14.5523 1 15 1.44772 15 2V9C15 9.55229 14.5523 10 14 10H10.5C9.94772 10 9.5 9.55229 9.5 9Z",
    fill: "#C175EE",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37 9V2C37 1.44772 37.4477 1 38 1H41.5C42.0523 1 42.5 1.44772 42.5 2V9C42.5 9.55229 42.0523 10 41.5 10H38C37.4477 10 37 9.55229 37 9Z",
    fill: "#C175EE",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24H19",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 33H19",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 33H10",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 41H19",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7 41H10",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24H28",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25 33H28",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24H36",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42 24H45",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33H36",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScheduleUser);
export default __webpack_public_path__ + "static/media/icon-schedule-user.b135214cbd51396a68abc6c8a6c98dfe.svg";
export { ForwardRef as ReactComponent };